<template>
  <div class="coords-container">
    <label>Longitude:</label>
    <vs-input
      v-model="point.lon"
      :danger="!isLonValid"
      icon="place"
      class="coord-input"
      size="small"
      danger-text="Must be a number from -180 to 180"
      @input="inputChange()"
    />
    <label>Latitude:</label>
    <vs-input
      v-model="point.lat"
      :danger="!isLatValid"
      icon="place"
      size="small"
      danger-text="Must be a number from -90 to 90"
      class="coord-input"
      @input="inputChange()"
    />
  </div>
</template>
<script>
export default {
  props: {
    point: {
      type: Object,
      required: true
    }
  },
  computed: {
    isLonValid() {
      return this.point.lon < 180 && this.point.lon > -180 && this.point.lon;
    },
    isLatValid() {
      return this.point.lat < 90 && this.point.lat > -90 && this.point.lat;
    }
  },
  methods: {
    inputChange() {
      this.$emit("coords-updated", {
        lon: this.point.lon,
        lat: this.point.lat
      });
    }
  }
};
</script>
<style scoped>
.coords-container {
  justify-content: center;
  display: flex;
  margin-left: 50px;
  align-items: center;
}
.coord-input {
  margin-left: 10px;
  margin-right: 10px;
}

.coord-input >>> .vs-input--icon {
  font-size: 0.8rem !important;
}
</style>
